import { render } from "./VisitUniversity.vue?vue&type=template&id=7e48160e&scoped=true"
import script from "./VisitUniversity.vue?vue&type=script&lang=js"
export * from "./VisitUniversity.vue?vue&type=script&lang=js"

import "./VisitUniversity.vue?vue&type=style&index=0&id=7e48160e&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e48160e"]])

export default __exports__